import SmoothScroll from 'smooth-scroll';

const smoothScroll = (selector, offset = 0) => {
  const anchor = document.querySelector(selector);
  const scroll = new SmoothScroll(null, {
    offset,
  });
  scroll.animateScroll(anchor);
};
export default smoothScroll;
